<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <material-feature-card
        v-for="f in features"
        :key="f.id"
        :icon="f.icon"
        :title="$t('features.' + f.id + '.title')"
        :description="$t('features.' + f.id + '.description')"
        :link="f.link"
        color="#132339"
      />
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      features: [
        {
          id: "adapters",
          icon: "mdi-link",
          link: "/if"
        },
        {
          id: "graphicEditor",
          icon: "mdi-relative-scale",
          link: "/ib"
        },
        {
          id: "webchat",
          icon: "mdi-message-processing",
          link: "/channels/webchat/static/chat.html"
        },
        {
          id: "configuration",
          icon: "mdi-settings",
          link: "/config"
        },
        {
          id: "monitoring",
          icon: "mdi-chart-areaspline",
          link: "/grafana"
        },
        {
          id: "cards",
          icon: "mdi-cookie",
          link: "/adminbot/static/designer.html"
        },
        {
          id: "intentParser",
          icon: "mdi-format-color-text",
          link: ""
        },
        {
          id: "stateMachine",
          icon: "mdi-autorenew",
          link: ""
        },
        {
          id: "store",
          icon: "mdi-sd",
          link: ""
        }
      ]
    };
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    }
  }
};
</script>
